import React from 'react';

import styled from 'styled-components';
import { animateScroll } from 'react-scroll';
import { colors } from 'z-react-components';
import { Button } from '@zanichelli/react-components';

const TwoColorsSection = styled.div`
    background-color: ${colors.grey300};
    background-image: -webkit-linear-gradient(150deg, ${colors.grey300} 50%, ${colors.grey100} 50%);
    display: flex;

    @media screen and (max-width: 920px) {
        background-image: -webkit-linear-gradient(90deg, ${colors.grey300} 50%, ${colors.grey100} 50%);
        flex-direction: column;
        align-items: center;
    }
`;

const LoginBox = styled.div`
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: 58px 24px;
`;

const Circle = styled.div`
    background-color: ${colors.white};
    height: 177px;
    width: 177px;
    border-radius: 50%;
    margin-bottom: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const LoginBoxText = styled.div`
    text-align: center;
    font-size: 20px;
`;

const ButtonContainer = styled.div`
    margin-top: 32px;
    display: flex;
    justify-content: center;
`;

const LoginAndSignUp = () => (
    <TwoColorsSection>
        <LoginBox>
            <Circle>
                <img src="/_assets/images/landingV2/icon_login.svg" alt="login-icon" />
            </Circle>
            <LoginBoxText>
                {'SEI GIÀ REGISTRATO A MY ZANICHELLI?'}
                <br />
                {'Accedi con il tuo account.'}
                <br />
                <ButtonContainer>
                    <Button label="ACCEDI" type="primary" shape="square" onClick={() => animateScroll.scrollToTop({ duration: 200 })} />
                </ButtonContainer>
            </LoginBoxText>
        </LoginBox>
        <LoginBox>
            <Circle>
                <img src="/_assets/images/landingV2/icon_signup.svg" alt="login-signup" />
            </Circle>
            <LoginBoxText>
                {'NON SEI ANCORA REGISTRATO?'}
                <br />
                {'Registrati a MyZanichelli.'}
                <br />
                <ButtonContainer>
                    <a style={{ textDecoration: 'none' }} href={'https://my.zanichelli.it/registrazione'} target={'_blank'}>
                        <Button label="REGISTRATI" type="primary" shape="square" />
                    </a>
                </ButtonContainer>
            </LoginBoxText>
        </LoginBox>
    </TwoColorsSection>
);

export default LoginAndSignUp;
